module.exports = __webpack_public_path__ + "img/project-cover1.823a1af1.jpeg";